export interface CalculatorRecipe {
  cardId: number
  title: string
}

/**
 * Рецепты, для которых доступен калькулятор: только в их тексте прописаны
 * форма, высота и вес, без которых пересчитывать нечего.
 *
 * Названия держим здесь, а не берём из загруженного списка карточек: список
 * зависит от доступов пользователя, и калькулятор формы оставался бы без
 * выбора рецепта. Живое название с бэка, если оно есть, имеет приоритет.
 */
export const CALCULATOR_RECIPES: readonly CalculatorRecipe[] = [
  { cardId: 650, title: 'Торт «ФИСТАШКА-МАЛИНА»' },
  { cardId: 655, title: 'Торт «ТРОПИЧЕСКИЙ»' },
  { cardId: 709, title: 'Торт «ЧЕРНЫЙ ЛЕС»' },
  { cardId: 707, title: 'Торт «СНИКЕРС»' },
  { cardId: 660, title: 'Торт «ВАНИЛЬ-ЯГОДЫ»' },
  { cardId: 631, title: 'Торт «НУТЕЛЛА»' },
  { cardId: 606, title: 'Торт «МЕДОВИК»' },
  { cardId: 622, title: 'Торт «БАНАНОВЫЙ»' },
  { cardId: 890, title: 'Торт «ИМБИРНЫЙ ПРЯНИК»' },
  { cardId: 549, title: 'Торт «МОЛОЧНАЯ ДЕВОЧКА»' },
  { cardId: 857, title: 'Торт «КОКОС-ВИШНЯ»' },
  { cardId: 858, title: 'Торт «ЛАВАНДА-ЛИМОН-СМОРОДИНА»' },
  { cardId: 859, title: 'Торт «КОФЕ-ФУНДУК»' },
  { cardId: 860, title: 'Торт «ТРЮФЕЛЬ»' },
  { cardId: 626, title: 'Торт «ФРЕЗЬЕ»' },
  { cardId: 643, title: 'Торт «МОРКОВНЫЙ С КАРАМЕЛЬЮ»' },
  { cardId: 670, title: 'Торт в форме тыквы «ПРЯНАЯ ГРУША»' },
  { cardId: 729, title: 'Торт «ЭСТЕРХАЗИ»' },
  { cardId: 730, title: 'Торт «ПРАГА»' },
  { cardId: 731, title: 'Торт «ПТИЧЬЕ МОЛОКО»' },
  { cardId: 768, title: 'Торт «МОЛОЧНЫЙ ЛОМТИК»' },
  { cardId: 769, title: 'Торт «РАФАЭЛЛО»' },
  { cardId: 770, title: 'Торт «ОРЕО»' },
  { cardId: 771, title: 'Торт «ФЕРРЕРО»' },
  { cardId: 792, title: 'Торт «СМЕТАННИК»' },

  // Партия из задачи Pauline-621. Названия временные: они видны только
  // тогда, когда карточка не пришла в списке доступного пользователю
  // контента — живое название с бэка всегда в приоритете.
  { cardId: 1006, title: 'Торт «НАПОЛЕОН»' },
  { cardId: 1003, title: 'Рецепт № 1003' },
  { cardId: 1000, title: 'Рецепт № 1000' },
  { cardId: 1001, title: 'Рецепт № 1001' },
  { cardId: 1005, title: 'Рецепт № 1005' },
  { cardId: 1042, title: 'Рецепт № 1042' },
  { cardId: 1097, title: 'Рецепт № 1097' },
  { cardId: 1020, title: 'Рецепт № 1020' },
  { cardId: 1043, title: 'Рецепт № 1043' },
  { cardId: 1041, title: 'Рецепт № 1041' },
  { cardId: 1044, title: 'Рецепт № 1044' },
  { cardId: 922, title: 'Рецепт № 922' },
  { cardId: 928, title: 'Рецепт № 928' },
  { cardId: 616, title: 'Рецепт № 616' },
  { cardId: 617, title: 'Рецепт № 617' },
  { cardId: 618, title: 'Рецепт № 618' },
  { cardId: 619, title: 'Рецепт № 619' },
  { cardId: 620, title: 'Рецепт № 620' },
  { cardId: 588, title: 'Рецепт № 588' },
  { cardId: 658, title: 'Рецепт № 658' },
  { cardId: 739, title: 'Рецепт № 739' },
  { cardId: 783, title: 'Рецепт № 783' },
  { cardId: 784, title: 'Рецепт № 784' },
  { cardId: 785, title: 'Рецепт № 785' },
]

/** Быстрая проверка доступа: используется кнопкой «Пересчитать» в рецепте. */
export const CALCULATOR_RECIPE_IDS = new Set(
  CALCULATOR_RECIPES.map(recipe => recipe.cardId)
)
